

export default class PList {

    constructor(arr) {

        if (arr === undefined || arr === null || typeof arr != 'object' || arr.length === undefined) {
            arr = [];
        }

        this.array = arr;

        this.Where = this.Where.bind(this);
        this.Select = this.Select.bind(this);
        this.Distinct = this.Distinct.bind(this);

        this.ToArray = this.ToArray.bind(this);
        this.ToTable = this.ToTable.bind(this);
    }

    Where(lambda) {
        let tmpArray = [];
        this.array.forEach(el => { tmpArray.push(el) });

        tmpArray = tmpArray.reduce((r, e) => {
            if (lambda(e)) {
                r.push(e);
            }

            return r;
        }, []);

        return new PList(tmpArray);
    }

    Select(propList) {
        let tmpArray = [];
        this.array.forEach(el => { tmpArray.push(el) });

        if (typeof propList === "function") {
            tmpArray = tmpArray.reduce((r, e) => {

                let tmpObj = propList(e);

                r.push(tmpObj);

                return r;
            }, []);
        } else {
            tmpArray = tmpArray.reduce((r, e) => {

                let tmpObj = {};
                propList.forEach(el => {
                    tmpObj[el] = e[el];
                });
                r.push(tmpObj);

                return r;
            }, []);
        }

        return new PList(tmpArray);
    }

    Distinct() {
        let tmpArray = [];
        this.array.forEach(el => { tmpArray.push(el) });

        tmpArray = Object.values(tmpArray.reduce((r, e) => {

            if (typeof e === 'object') {
                let key = JSON.stringify(e);
                if (!r[key]) {
                    r[key] = e;
                }
            } else {
                let key = e;
                if (!r[key]) {
                    r[key] = e;
                }
            }

            return r;
        }, {}));

        return new PList(tmpArray);
    }

    ToArray() {
        return this.array;
    }

    ToTable() {
        
    }
}